<template>
  <div class="wrapper">
    <header class="bg">
      <!-- <router-link to="/" class="back">← 返回首页</router-link> -->
      <h2>UED-CDN</h2>
      <div class="logo-page"><img src="../assets/images/iview.png" /></div>
      <p>Iview</p>
    </header>
    <section>
      <file-list :fileList="fileList"></file-list>
    </section>
  </div>
</template>

<script>
const ur = "https://uedcdn.zto.com/static/iview/";
export default {
  name: "index",
  data() {
    return {
      fileList: [
        {
          label: "4.2.0",
          linkList: [
            ur + "4.2.0/iview.js",
            ur + "4.2.0/iview.min.js",
            ur + "4.2.0/locale/zh-CN.js",
            ur + "4.2.0/style/iview.css"
          ]
        },
        {
          label: "3.5.4",
          linkList: [
            ur + "3.5.4/iview.js",
            ur + "3.5.4/iview.min.js",
            ur + "3.5.4/locale/zh-CN.js",
            ur + "3.5.4/style/iview.css"
          ]
        },
        {
          label: "3.0.1",
          linkList: [
            ur + "3.0.1/iview.js",
            ur + "3.0.1/iview.min.js",
            ur + "3.0.1/iview.js.map",
            ur + "3.0.1/iview.min.js.map",
            ur + "3.0.1/local/zh-CN.js",
            ur + "3.0.1/style/iview.css"
          ]
        },
        {
          label: "2.14.0",
          linkList: [
            ur + "2.14.0/iview.js",
            ur + "2.14.0/iview.min.js",
            ur + "2.14.0/local/zh-CN.js",
            ur + "2.14.0/style/iview.css"
          ]
        },
        {
          label: "2.13.1",
          linkList: [
            ur + "2.13.1/iview.js",
            ur + "2.13.1/iview.min.js",
            ur + "2.13.1/local/zh-CN.js",
            ur + "2.13.1/style/iview.css"
          ]
        },
        {
          label: "2.13.0",
          linkList: [
            ur + "2.13.0/iview.js",
            ur + "2.13.0/iview.min.js",
            ur + "2.13.0/local/zh-CN.js",
            ur + "2.13.0/style/iview.css"
          ]
        }
      ]
    };
  }
};
</script>



// WEBPACK FOOTER //
// src/view/ListIview.vue